import { render, staticRenderFns } from "./Archimedes.vue?vue&type=template&id=30211cde&scoped=true&"
import script from "./Archimedes.vue?vue&type=script&lang=js&"
export * from "./Archimedes.vue?vue&type=script&lang=js&"
import style0 from "./Archimedes.vue?vue&type=style&index=0&id=30211cde&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30211cde",
  null
  
)

export default component.exports